module.exports = __webpack_public_path__ + "static/slide-2-12d385147f9e5b2481da3b95f968419a.svg";